import { mapFields } from "vuex-map-fields";
import { calendarRangeDateSet } from "@/mixins/basicComponent";

/**
 * 알림서비스 목록
 */
export const RBF0401P40 = {
  mixins: [calendarRangeDateSet],
  computed: {
    ...mapFields("common/main", ["isCustNtcInq", "isCustNtc3Inq", "RBF0401P40", "initRBF0401P40", "isCustNtc"]),
  },
  methods: {
    RBF0401P40mainCall() {
      //메인에서 조회시(알림아이콘) 일주일 기간으로 조회
      if (_.isEmpty(this.RBF0401P40.dataGrid)) {
        let params = {
          startYmd: this.setChangeDate(this.$getDateToString(), this.$config.CALENDAR_RANGE_1W), //조회시작일자
          endYmd: this.$getDateToString(), //조회종료일자
        };

        this.$post(
          "/customer/notice/inqCustNotice",
          params,
          this.RBF0401P40mainSuc,
          null,
          () => {
            this.isCustNtcInq = true;
          },
          null,
          false,
        );
      }
    },
    RBF0401P40mainSuc(res) {
      if (res.outItem.dataGrid.length > 0) {
        this.isCustNtc = true;
      }
      this.initRBF0401P40 = Object.freeze(res.outItem);
    },
    RBF0401P40Call(frDate, toDate) {
      //알림서비스 메뉴에서 조회시, 3개월 기간으로 조회
      let params = {
        startYmd: frDate,
        endYmd: toDate,
      };

      this.$post(
        "/customer/notice/inqCustNotice",
        params,
        this.RBF0401P40Suc,
        null,
        () => {
          this.isCustNtc3Inq = true;
        },
        null,
        false,
      );
    },
    RBF0401P40Suc(res) {
      this.RBF0401P40 = Object.freeze(res.outItem);
    },
  },
};


